import type { FormattersInitializer } from 'typesafe-i18n';
import type { Locales, Formatters } from './i18n-types';
import { formatDuration } from 'date-fns';
import { dateLocales } from '$lib/utils/locale-date';

const suffixes: Record<string, Map<string, string>> = {
  en: new Map([
    ['one', 'st'],
    ['two', 'nd'],
    ['few', 'rd'],
    ['other', 'th'],
  ]),
  fr: new Map([
    ['one', 'er'],
    ['two', 'e'],
    ['few', 'e'],
    ['other', 'e'],
  ]),
};

export const initFormatters: FormattersInitializer<Locales, Formatters> = (locale: Locales) => {
  const formatters: Formatters = {
    ordinal: (value) => {
      if (typeof value !== 'number') {
        return value;
      }
      const pluralRules = new Intl.PluralRules(locale, { type: 'ordinal' });
      const rule = pluralRules.select(value);
      const suffix = suffixes[locale].get(rule);
      return `${value}${suffix}`;
    },
    seconds: (value) =>
      formatDuration({ seconds: value as number }, { locale: dateLocales[locale] }),
  };

  return formatters;
};
